import { Component, OnInit, Inject } from '@angular/core';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-all-bookmark-list',
  templateUrl: './all-bookmark-list.component.html',
  styleUrls: ['./all-bookmark-list.component.css']
})
export class AllBookmarkListComponent implements OnInit {
bookmarkList:any=[];
Counter = 5;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rolesSharedService: RolesSharedService) {
      this.document.body.classList.add("inner-page");
      this.document.body.classList.remove("outer-page");
     }

  ngOnInit() {
 //  this.getBookmarkList('');
  }
  getBookmarkList(filter) {
    this.rolesSharedService.getBookMarkList(filter).subscribe(
      (resp: any) => {
        this.bookmarkList = resp.data;
      },
      error => {

      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/all-bookmark-list/all-bookmark-list.component.ts